import '../App.css';
import '../styles/topSection.css'
import Logo from '../components/Logo';
import Button from '../components/Button';
import Socials from '../components/Socials'

import { ToastContainer } from 'react-toastify';

interface props {
    callback: (loc: string) => void
}

function TopSection({callback}: props) {
    return (
        <div className='top-section'>
            <div className='top-section-inner'>
                <ToastContainer closeOnClick={false} hideProgressBar autoClose={1000}></ToastContainer>
                <Logo size="large"></Logo>
                <Button type="primary" text="Join" callback={() => callback('join')}></Button>
                <hr className='half-keyline'></hr>
                <Socials/>
                <div className="scroll-to-learn-container">
                    <p className="scroll-to-learn">Scroll to learn more</p>
                    <Button type="scroll" callback={() => callback('about')}></Button>
                </div>
            </div>
            
        </div>
    );
}

export default TopSection;
